<template>
  <div id="WithdrawalRecord">
    <Dialog ref="dialog" :config="config">
      <div class="remittanceScreenshotsBox">
        <!-- 备注 -->
        <div class="remarkbox" v-if="row.client_reason">
          <h2> {{ $fanyi('提现申请原因') }}</h2>
          <textarea :disabled="true" v-model="row.client_reason" name="" id=""></textarea>
        </div>

        <!-- 汇款截图 -->
        <div class="Remittancescreenshot" v-if="row.pay_image">

          <div class="top">
            <span>{{ $fanyi('汇款截图') }}</span>
            <span @click="
              downLoadImg(
                row.pay_image,
                row.pay_image.substr(row.pay_image.lastIndexOf('/') + 1)
              )"> <img src="../../../../../assets/OrderDetails/download.svg" alt=""> {{ $fanyi('下载') }}</span>

          </div>
          <div class="picbox">
            <img :src="row.pay_image" alt="">
          </div>
        </div>


      </div>
    </Dialog>
    <div class="searchBox" v-loading.fullscreen.lock="imgloading" element-loading-background="rgba(0, 0, 0, 0.3)">
      <div class="left">
        <el-date-picker v-model="value1" type="datetimerange" :range-separator="$fanyi('')"
          :start-placeholder="$fanyi('开始日期')" :end-placeholder="$fanyi('结束日期')" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd" :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
        <button class="searchBtn" @click="getData">{{ $fanyi('搜索') }}</button>
      </div>


      <span class="exportBtn" @click="$fun.toPage('/user/paymentsummary')">
        {{ $fanyi('返回') }}</span>
    </div>
    <div class="dataBody" v-loading="loading">
      <el-table :data="tableData" border :header-cell-style="{
        background: '#F5F5F5',
        height: '50px',
        'font-size': '14px',
        border: 'none',
        color: '#121212',
        'font-weight': '500',
        'text-align': 'center',
      }" :cell-style="{
        'text-align': 'center',
        color: '#121212',
        'font-size': '14px',
        height: '60px',
      }">
        <el-table-column type="index" width="50" label="No">
        </el-table-column>
        <el-table-column property="created_at" :label="$fanyi('发起时间')" width="100">
          <template slot="header" slot-scope="scope">
            <div class="tableHead" :title="$fanyi('发起时间')">
              {{ $fanyi('发起时间') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$fanyi('流水号')" width="180">
          <template slot="header" slot-scope="scope">
            <div class="tableHead" :title="$fanyi('流水号')">
              {{ $fanyi('流水号') }}
            </div>
          </template>
          <template slot-scope="scope">
            <div class="liushuihao" :title="$fanyi('流水号')">
              {{ scope.row.serial_number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="client_name" :label="$fanyi('收款户名')" width="140">
          <template slot="header" slot-scope="scope">
            <div class="tableHead" :title="$fanyi('收款户名')">
              {{ $fanyi('收款户名') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="client_account" :label="$fanyi('收款户号')" width="180">
          <template slot="header" slot-scope="scope">
            <div class="tableHead" :title="$fanyi('收款户号')">
              {{ $fanyi('收款户号') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="client_amount" :label="$fanyi('提现金额')" width="100">
          <template slot="header">
            <div class="tableHead" :title="$fanyi('提现金额')">
              {{ $fanyi('提现金额') }}
            </div>
          </template>
          <template slot-scope="scope">
            <div>₴{{ $fun.EURNumSegmentation(scope.row.client_amount) }}</div>
          </template>
        </el-table-column>
        <el-table-column property="status" :label="$fanyi('处理状态')" width="140">
          <template slot="header" slot-scope="scope">
            <div class="tableHead" :title="$fanyi('处理状态')">
              {{ $fanyi('处理状态') }}
            </div>
          </template>
          <template slot-scope="scope">
            <div>
              {{ $fanyi(scope.row.status) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$fanyi('明细')">
          <template slot-scope="scope">
            <div class="details" v-if="scope.row.client_reason || scope.row.pay_image" @click="showdetails(scope.row)">
              {{ $fanyi('明细') }}
            </div>
            <span v-else>---</span>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="allpag">

      <el-pagination @current-change="handleCurrentChange" :current-page="form.currentPage" :page-size="10"
        :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import Dialog from '../../../../../components/public/Dialog'

export default {
  data() {
    return {
      value1: [],
      loading: false,
      form: {
        status: 'temporary',
        page: 1,
        pageSize: 10,
        searchText: '',
        startTime: '',
        endTime: '',
      },
      tableData: [
        {
          date: 'dsfad',
        },
      ],

      total: 0,
      imgloading: false,
      row: {}, //查看凭证的的一项数据
      config: {
        top: '20vh',
        width: '640px',
        title: '',
        btnTxt: [],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true,
        this.$api
          .capitalCashOutList({
            pageSize: this.form.pageSize,
            startTime: this.value1 ? this.value1[0] : '',
            endTime: this.value1 ? this.value1[1] : '',
            page: this.form.page,
          })
          .then((res) => {
            this.loading = false
            if (res.code != 0) return

            this.tableData = res.data.data
            this.total = res.data.total
          })
    },

    downLoadImg(data, fileName) {
      this.imgloading = true
      this.$api
        .downloadFile({
          file_url: data,
        })
        .then((res) => {
          this.imgloading = false
          this.downloadFileByBase64(res.data.file_data, fileName)
        })
    },
    //下载方法
    downloadFile(url, name = 'imagen') {
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    }, downloadFileByBase64(base64, name) {
      var myBlob = this.dataURLtoBlob(base64)
      var myUrl = URL.createObjectURL(myBlob)
      this.downloadFile(myUrl, name)
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },

    handleCurrentChange(val) {
      this.form.page = val
      this.getData()
    },
    showdetails(row) {
      this.row = row
      this.$refs.dialog.open()
    },
  },
  components: { Dialog },
  computed: {},
}
</script>
<style lang="scss" scoped>
#WithdrawalRecord {
  @import '../../../../../css/mixin';
  width: 1060px;

  background: #FFFFFF;
  border-radius: 20px;
  padding: 30px 20px;
  padding-bottom: 10px;

  .searchBox {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;

    .left {
      /deep/.el-date-editor {
        border-radius: 12px;
        width: 296px;
        height: 40px;
        margin-right: 20px;
        line-height: 32px !important;

        .el-input__inner {
          padding: 0px !important;
          border-radius: 12px;
        }

        .el-range__icon {
          display: none;
        }

        .el-range-input {
          font-size: 14px;
          border-radius: 12px;
        }

        .el-range-separator {
          width: 50px;
          line-height: 23px;
        }

        .el-range__icon {
          line-height: 25px;
        }
      }

      .searchBtn {
        width: 80px;
        height: 40px;
        background: #d12a1d;
        border-radius: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
      }
    }

    .exportBtn {

      height: 40px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 16px;
      color: #d12a1d;
      padding: 0 15px;
      border: 1px solid #d12a1d;

      &:hover {
        cursor: pointer;
      }
    }
  }

  /deep/.el-table {
    border-radius: 12px;

    overflow: hidden;
    border-bottom: none;
    border-color: #dfdfdf;

    .el-table__cell {
      border-color: #dfdfdf;

    }

    tr {
      border-color: #dfdfdf;

      &:last-child {


        overflow: hidden;

        td {

          &:first-child {
            border-radius: 0 0 0px 12px;
          }

          &:last-child {
            border-radius: 0 0 12px 0px;
          }

        }
      }
    }

    .el-table__empty-block {
      border-radius: 0 0 12px 12px;
    }
  }

  /deep/.el-table__header-wrapper {

    border-bottom: 1px solid #dfdfdf;

    .cell {
      line-height: 14px;
    }
  }

  /deep/.el-table__empty-block {
    height: 80px !important;
    border-bottom: 0.5px solid #dfdfdf;
  }

  .dataBody {
    min-height: 180px;

    .details {
      font-weight: normal;
      font-size: 14px;
      color: #2052CE;
      line-height: 16px;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }


  .allpag {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0px;

    .el-pagination {
      display: flex;
      align-items: center;
    }

    >a {
      display: inline-block;
      border: 1px solid #dcdfe6;
      height: 28px;
      // background-color: white;
      text-align: center;
      padding: 0 10px;
      font-size: 13px;
      line-height: 28px;
      border-radius: 0;
    }

    /deep/.btn-prev {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dfdfdf;
      padding: 0;
      margin-right: 15px;
      margin-left: 20px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/.btn-next {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dfdfdf;
      padding: 0;
      margin-left: 15px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/ .el-pagination__jump {
      .el-input {
        width: 50px;
        height: 30px;
        background: #ffffff;
        border-radius: 8px;
        margin-left: 5px;

        font-weight: 400;
        font-size: 14px;
        color: #000000;

        .el-input__inner {
          height: 30px;
          border-radius: 8px;
        }
      }
    }

    /* 分页被选中的页码样式 */
    /deep/ .el-pager li {
      margin: 0 5px;
      width: 30px;
      line-height: 30px;
      height: 30px;
      border-radius: 8px;
      // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

      &:hover {
        color: #d12a1d;
      }

      &.active {
        width: 30px;

        height: 30px;
        background: #d12a1d;
        line-height: 30px;
        color: #fff;
        border-radius: 8px;
      }
    }
  }
}

/deep/.el-dialog__body {
  padding-top: 0px !important;
  padding-bottom: 40px;
}

/deep/.el-dialog {
  padding-bottom: 10px !important;
}

.remittanceScreenshotsBox {
  .remarkbox {
    margin-bottom: 40px;

    h2 {
      font-weight: normal;
      font-size: 16px;
      color: #121212;
      padding: 15px;
      line-height: 20px;
      padding: 0px;
      font-weight: normal;
      font-size: 14px;
      color: #121212;
      line-height: 16px;
      margin-bottom: 30px;
    }

    textarea {
      width: 560px;
      height: 160px;
      padding: 15px;
      background: #FFFFFF;
      border-radius: 12px;
      border: 1px solid #DFDFDF;
    }
  }

  .Remittancescreenshot {
    .top {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        &:first-child {
          font-weight: normal;
          font-size: 16px;
          color: #121212;
          line-height: 20px;
          margin-right: 35px;
        }

        &:last-child {
          min-width: 110px;
          height: 40px;
          background: #FFFFFF;
          border-radius: 10px;
          border: 1px solid #DFDFDF;
          padding: 0 15px;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            cursor: pointer;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }

    .picbox {
      width: 560px;
      height: 320px;
      background: #FFFFFF;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #DFDFDF;

      img {
        width: 300px;
        height: 300px;
      }
    }
  }
}
</style>
